import { DRAWER_CONTEXT } from "@models/DrawerContext";
import {
  registerDrawerForm,
  DrawerFormProps,
} from "@common/SimpleDrawer/drawerFormRegistry";
import { ProductForm } from "@features/products/components/forms/ProductForm/ProductForm";
import { LocationForm } from "@features/locations/components/forms/LocationForm/LocationForm";
import { StockForm } from "@features/stocks/components/forms/StockForm/StockForm";
import { StageForm } from "@features/stocks/components/forms/StageForm/StageForm";
import { TagForm } from "@features/tags/components/forms/TagForm/TagForm";
import { OrderForm } from "@features/orders/components/forms/OrderForm/OrderForm";
import { CustomerForm } from "@features/customers/components/forms/CustomerForm/CustomerForm";
import { SupplierForm } from "@features/suppliers/components/forms/SupplierForm/SupplierForm";
import { PurchaseOrderForm } from "@features/purchase-orders/components/forms/PurchaseOrderForm/PurchaseOrderForm";

/**
 * App composition root for drawer forms: maps each DRAWER_CONTEXT to a feature's
 * form + title for the generic `DrawerHost`. This is the one place allowed to
 * depend on features — so the drawer host and `shared/` never do. Create and
 * edit contexts share a form; the form branches on `context` from the URL.
 * Call once during bootstrap.
 */
export function registerDrawerForms(): void {
  register(DRAWER_CONTEXT.CREATE_PRODUCT, "Create Product", (p) => (
    <ProductForm {...p} />
  ));
  register(DRAWER_CONTEXT.EDIT_PRODUCT, "Edit Product", (p) => (
    <ProductForm {...p} />
  ));

  register(DRAWER_CONTEXT.CREATE_LOCATION, "Create Location", (p) => (
    <LocationForm {...p} />
  ));
  register(DRAWER_CONTEXT.EDIT_LOCATION, "Edit Location", (p) => (
    <LocationForm {...p} />
  ));

  register(DRAWER_CONTEXT.CREATE_STOCK, "Add Stock", (p) => <StockForm {...p} />);
  register(DRAWER_CONTEXT.EDIT_STOCK, "Edit Stock", (p) => <StockForm {...p} />);

  register(DRAWER_CONTEXT.CREATE_TAG, "Create Tag", (p) => <TagForm {...p} />);
  register(DRAWER_CONTEXT.EDIT_TAG, "Edit Tag", (p) => <TagForm {...p} />);

  register(DRAWER_CONTEXT.CREATE_STAGE, "Create Stage", (p) => (
    <StageForm {...p} />
  ));
  register(DRAWER_CONTEXT.EDIT_STAGE, "Edit Stage", (p) => <StageForm {...p} />);

  register(DRAWER_CONTEXT.CREATE_ORDER, "Create Order", (p) => (
    <OrderForm {...p} />
  ));
  register(DRAWER_CONTEXT.EDIT_ORDER, "Edit Order", (p) => <OrderForm {...p} />);

  register(DRAWER_CONTEXT.CREATE_CUSTOMER, "Create Customer", (p) => (
    <CustomerForm {...p} />
  ));
  register(DRAWER_CONTEXT.EDIT_CUSTOMER, "Edit Customer", (p) => (
    <CustomerForm {...p} />
  ));

  register(DRAWER_CONTEXT.CREATE_SUPPLIER, "Create Supplier", (p) => (
    <SupplierForm {...p} />
  ));
  register(DRAWER_CONTEXT.EDIT_SUPPLIER, "Edit Supplier", (p) => (
    <SupplierForm {...p} />
  ));

  register(DRAWER_CONTEXT.CREATE_PURCHASE_ORDER, "Create Purchase Order", (p) => (
    <PurchaseOrderForm {...p} />
  ));
  register(DRAWER_CONTEXT.EDIT_PURCHASE_ORDER, "Edit Purchase Order", (p) => (
    <PurchaseOrderForm {...p} />
  ));
}

function register(
  context: DRAWER_CONTEXT,
  title: string,
  render: (props: DrawerFormProps) => JSX.Element
): void {
  registerDrawerForm(context, { title, render });
}
